// src/redux/slices/ictSkillsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ictSkillsData: [],
  source: '',
};

const ictSkillsSlice = createSlice({
  name: 'ictSkills',
  initialState: {
    ictSkillsData: []  // Initialize as empty array
  },
  reducers: {
    setICTSkillsData: (state, action) => {
      state.ictSkillsData = action.payload;
    },
    addOrUpdateSkillEntry: (state, action) => {
      state.ictSkillsData = action.payload;
    },
    setSource: (state, action) => {
      state.source = action.payload;

       if (Array.isArray(state.source)) {
    state.source = state.source.map(item => ({
      ...item,
      source: action.payload,
    }));
  }
    },
    setCensusYear: (state, action) => {
      state.censusYear = action.payload;
    },
    setProvinceId: (state, action) => {
      state.provinceId = action.payload;
    },
    resetICTSkills: () => initialState,
  },
});

export const {
  setICTSkillsData,
  addOrUpdateSkillEntry,
  setSource,
  setCensusYear,
  setProvinceId,
  resetICTSkills,
} = ictSkillsSlice.actions;

export default ictSkillsSlice.reducer;
